module.exports = __webpack_public_path__ + "img/slide8.497afd62.png";